import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import LayersIcon from "@mui/icons-material/Layers";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TextField from "../../../common/TextField";
import Button from "../../../common/Button";
import { updateAccount } from "../../../../Actions/Accounts";
import { checkPrivileges } from "../../../../Helpers";
import {
  notifyError,
  notifySuccess,
} from "../../../../Utils/CustomNotifcations";
import withTranslationWrapper from "../../../../HOC/HocTranslate";
import { apiFetch } from "../../../../Utils/apiFetch";
import "./theme-catalog.scss";
import "../Components/index.scss";

const FLOTILLA_THEMES = [
  "default",
  "default-dark",
  "apex",
  "marina-dark",
  "fleetlink",
];

const APP_NAV = ["Dashboard", "Monitoring", "Trackers", "Drivers", "Reports"];

const THEME_PREVIEWS = {
  default: {
    cmsLabel: "Default",
    swatch: "#51c3c8",
    colors: {
      primary: "#002b32",
      accent: "#51c3c8",
      bg: "#e9f1f5",
      card: "#ffffff",
      side: "#d7ecef",
      sideText: "#1c2a3a",
      ink: "#1c2a3a",
      line: "#c5d8de",
      top: "#ffffff",
      muted: "#eef3f4",
      mutedFg: "#7E92A2",
      rowHover: "#eef3f4",
      rowActive: "#61c9cd33",
      success: "#3aaf5d",
      warning: "#f38b21",
      danger: "#c62828",
      info: "#2185ff",
      purple: "#7c61a8",
      activeNav: "rgba(255,255,255,0.85)",
      activeNavText: "#1c2a3a",
      buttonText: "#ffffff",
      logoBg: "#ffffff",
    },
  },
  "default-dark": {
    cmsLabel: "Default Dark",
    swatch: "#0e181c",
    colors: {
      primary: "#51c3c8",
      accent: "#4db6ac",
      bg: "#0e181c",
      card: "#152328",
      side: "#0a1418",
      sideText: "#e8f0f3",
      ink: "#e8f0f3",
      line: "#2a424a",
      top: "#152328",
      muted: "#1a282e",
      mutedFg: "#8fa8b0",
      rowHover: "#1c2e34",
      rowActive: "#51c3c833",
      success: "#66bb6a",
      warning: "#ffa726",
      danger: "#ef5350",
      info: "#42a5f5",
      purple: "#9575cd",
      activeNav: "#51c3c8",
      activeNavText: "#002b32",
      buttonText: "#002b32",
      logoBg: "#152328",
    },
  },
  apex: {
    cmsLabel: "Apex",
    swatch: "#EC431D",
    colors: {
      primary: "#EC431D",
      accent: "#EC431D",
      bg: "#ededed",
      card: "#ffffff",
      side: "#FCF9F8",
      sideText: "#2a2221",
      ink: "#130e0e",
      line: "#e6e2e1",
      top: "#ffffff",
      muted: "#f6f3f2",
      mutedFg: "#696160",
      rowHover: "#f6f3f2",
      rowActive: "#EC431D22",
      success: "#3aaf5d",
      warning: "#f38b21",
      danger: "#c62828",
      info: "#2185ff",
      purple: "#8b5cf6",
      activeNav: "#EC431D",
      activeNavText: "#ffffff",
      buttonText: "#ffffff",
      logoBg: "#ffffff",
    },
  },
  "marina-dark": {
    cmsLabel: "Marina Dark",
    swatch: "#0A83A1",
    colors: {
      primary: "#0A83A1",
      accent: "#0A83A1",
      bg: "#096d86",
      card: "#045266",
      side: "#045266",
      sideText: "#ffffff",
      ink: "#ffffff",
      line: "#0a83a180",
      top: "#045266",
      muted: "#0a5f75",
      mutedFg: "#ffffffcc",
      rowHover: "#135666",
      rowActive: "#0A83A1",
      success: "#4BB543",
      warning: "#ffa726",
      danger: "#ff424c",
      info: "#42a5f5",
      purple: "#9575cd",
      activeNav: "#0A83A1",
      activeNavText: "#ffffff",
      buttonText: "#ffffff",
      logoBg: "#045266",
    },
  },
  fleetlink: {
    cmsLabel: "Fleetlink",
    swatch: "#27a9e3",
    colors: {
      primary: "#27a9e3",
      accent: "#27a9e3",
      bg: "#e9edf2",
      card: "#ffffff",
      side: "#F9FAFC",
      sideText: "#232933",
      ink: "#0c121a",
      line: "#e2e5e9",
      top: "#ffffff",
      muted: "#f1f4f8",
      mutedFg: "#5d646f",
      rowHover: "#f1f4f8",
      rowActive: "#27a9e322",
      success: "#3aaf5d",
      warning: "#f38b21",
      danger: "#e62c2c",
      info: "#2185ff",
      purple: "#8b5cf6",
      activeNav: "#27a9e3",
      activeNavText: "#ffffff",
      buttonText: "#ffffff",
      logoBg: "#ffffff",
    },
  },
};

const COLOR_SWATCHES = [
  ["Primary", "primary"],
  ["Background", "bg"],
  ["Card", "card"],
  ["Logo", "logoBg"],
  ["Sidebar", "side"],
  ["Foreground", "ink"],
  ["Accent", "accent"],
  ["Border", "line"],
  ["Muted", "muted"],
  ["Success", "success"],
  ["Warning", "warning"],
  ["Danger", "danger"],
  ["Info", "info"],
];

const TRACKER_ROWS = [
  {
    unit: "Hilux-01",
    meta: "Toyota · 352094081234567",
    status: "success",
    selected: true,
  },
  {
    unit: "NPR-442",
    meta: "Isuzu · 352094081234568",
    status: "warning",
    selected: false,
  },
  {
    unit: "Canter-09",
    meta: "Fuso · 352094081234569",
    status: "danger",
    selected: false,
  },
  {
    unit: "Ranger-12",
    meta: "Ford · 352094081234570",
    status: "success",
    selected: false,
  },
];

function isThemeId(value) {
  return FLOTILLA_THEMES.indexOf(value) !== -1;
}

function statusColor(colors, status) {
  return colors[status];
}

function hexTint(hex, alpha) {
  const tint = alpha || "22";
  const h = (hex || "").trim();
  if (/^#[0-9a-fA-F]{6}$/.test(h)) return `${h}${tint}`;
  if (/^#[0-9a-fA-F]{8}$/.test(h)) return `${h.slice(0, 7)}${tint}`;
  return hex;
}

function ThemeBadge({ color, fill, fg, children }) {
  const solid = fill === "solid";
  return (
    <span
      className="theme-catalog__badge"
      style={
        solid
          ? { background: color, color: fg || "#fff" }
          : {
              background: hexTint(color),
              color,
              border: `1px solid ${hexTint(color, "44")}`,
            }
      }
    >
      {children}
    </span>
  );
}

function ThemeBadgeRow({ colors }) {
  return (
    <div className="theme-catalog__badge-row">
      <p className="theme-catalog__badge-row-title">Colors</p>
      <div className="theme-catalog__swatch-list">
        {COLOR_SWATCHES.map(([label, key]) => {
          const hex = colors[key];
          return (
            <div key={key} className="theme-catalog__color-chip">
              <span
                className="theme-catalog__color-chip-dot"
                style={{ background: hex }}
              />
              <span className="theme-catalog__color-chip-meta">
                <span className="theme-catalog__color-chip-label">{label}</span>
                <span className="theme-catalog__color-chip-hex">{hex}</span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function TrackerCompactBody({ colors }) {
  return (
    <div
      className="tc-tracker"
      style={{ background: colors.bg, color: colors.ink }}
    >
      <aside className="tc-tracker__list" style={{ background: colors.card }}>
        <div className="tc-tracker__tabs" style={{ background: colors.muted }}>
          <div
            className="tc-tracker__tab tc-tracker__tab--active"
            style={{
              borderColor: colors.primary,
              background: colors.muted,
              color: colors.ink,
            }}
          >
            <MenuIcon sx={{ fontSize: 14 }} />
            Trackers
          </div>
          <div
            className="tc-tracker__tab tc-tracker__tab--idle"
            style={{
              borderColor: colors.line,
              background: colors.card,
              color: colors.ink,
            }}
          >
            <LayersIcon sx={{ fontSize: 14 }} />
            Groups
          </div>
        </div>

        <div
          className="tc-tracker__search"
          style={{ background: colors.muted }}
        >
          <div
            className="tc-tracker__search-field"
            style={{ color: colors.ink }}
          >
            <SearchIcon sx={{ fontSize: 14, color: colors.primary }} />
            <span className="tc-tracker__search-placeholder">Search</span>
          </div>
          <span
            className="tc-tracker__add"
            style={{ background: colors.primary, color: colors.buttonText }}
          >
            <AddIcon sx={{ fontSize: 14 }} />
          </span>
        </div>

        <div
          className="tc-tracker__cols"
          style={{ borderColor: colors.line }}
        >
          <span>Tracker</span>
          <span>⋮</span>
        </div>

        {TRACKER_ROWS.map((row) => {
          const dot = statusColor(colors, row.status);
          return (
            <div
              key={row.unit}
              className="tc-tracker__row"
              style={{
                background: row.selected ? colors.rowActive : colors.card,
                color: colors.ink,
              }}
            >
              <div className="tc-tracker__row-main">
                <span
                  className="tc-tracker__icon"
                  style={{ background: colors.muted }}
                >
                  <span
                    className="tc-tracker__dot"
                    style={{ background: dot, borderColor: colors.card }}
                  />
                  <svg
                    viewBox="0 0 24 24"
                    className="tc-tracker__icon-svg"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M5 11h14l-1.2-3.5A2 2 0 0 0 15.9 6H8.1a2 2 0 0 0-1.9 1.5L5 11Zm-1 1v5h2v-1h12v1h2v-5H4Z" />
                  </svg>
                </span>
                <div className="tc-tracker__meta">
                  <p className="tc-tracker__unit">{row.unit}</p>
                  <p className="tc-tracker__sub">{row.meta}</p>
                </div>
              </div>
              <MoreVertIcon className="tc-tracker__more" sx={{ fontSize: 14 }} />
            </div>
          );
        })}
      </aside>

      <section
        className="tc-tracker__detail"
        style={{ background: colors.card }}
      >
        <header className="tc-tracker__header">
          <span
            className="tc-tracker__close"
            style={{ background: colors.muted, borderColor: colors.line }}
          >
            <CloseIcon sx={{ fontSize: 14 }} />
          </span>
          <span
            className="tc-tracker__divider"
            style={{ background: colors.line }}
          />
          <p className="tc-tracker__crumb">
            Trackers <span style={{ opacity: 0.4 }}>/</span> Hilux-01{" "}
            <span style={{ opacity: 0.4 }}>/</span>{" "}
            <span style={{ fontWeight: 500, opacity: 1 }}>Dashboard</span>
          </p>
          <div className="tc-tracker__header-badges">
            <ThemeBadge color={colors.primary} fill="solid" fg={colors.buttonText}>
              Primary
            </ThemeBadge>
            <ThemeBadge color={colors.success}>Online</ThemeBadge>
            <ThemeBadge color={colors.accent}>Today</ThemeBadge>
          </div>
        </header>

        <div className="tc-tracker__body">
          <nav
            className="tc-tracker__subnav"
            style={{ background: colors.side, color: colors.sideText }}
          >
            {["Dashboard", "Basic", "Overview", "Attributes", "Commands"].map(
              (item, i) => (
                <div
                  key={item}
                  className="tc-tracker__subnav-item"
                  style={
                    i === 0
                      ? {
                          background: colors.activeNav,
                          color: colors.activeNavText || colors.sideText,
                          fontWeight: 600,
                        }
                      : { opacity: 0.78 }
                  }
                >
                  {item}
                </div>
              )
            )}
          </nav>

          <div
            className="tc-tracker__content"
            style={{ background: colors.bg }}
          >
            <div className="tc-tracker__chips">
              <ThemeBadge
                color={colors.primary}
                fill="solid"
                fg={colors.buttonText}
              >
                Default
              </ThemeBadge>
              <ThemeBadge color={colors.primary}>GPS</ThemeBadge>
              <ThemeBadge color={colors.success}>Moving</ThemeBadge>
              <ThemeBadge color={colors.warning}>Idle</ThemeBadge>
              <ThemeBadge color={colors.danger}>Alert</ThemeBadge>
              <ThemeBadge color={colors.accent}>Fleet</ThemeBadge>
            </div>
            <div className="tc-tracker__cards">
              {[
                ["Distance", "128 km", colors.accent],
                ["Moving", "4 h 12 m", colors.success],
                ["Idle", "41 m", colors.warning],
                ["Engine", "6 h 02 m", colors.primary],
                ["Parking", "2 h 10 m", colors.ink],
                ["Trips", "9", colors.accent],
              ].map(([label, value, color]) => (
                <div
                  key={label}
                  className="tc-tracker__card"
                  style={{
                    background: colors.card,
                    borderColor: colors.line,
                  }}
                >
                  <div className="tc-tracker__card-label">{label}</div>
                  <div
                    className="tc-tracker__card-value"
                    style={{ color }}
                  >
                    {value}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

function HtmlPreview({ colors, activeNav, logo, children }) {
  const navActive = colors.activeNavText || colors.sideText;
  const activeIndex = APP_NAV.indexOf(activeNav);
  return (
    <div
      className="tc-html-preview"
      style={{
        background: colors.bg,
        color: colors.ink,
        borderColor: colors.line,
      }}
    >
      <aside
        className="tc-html-preview__side"
        style={{
          background: colors.side,
          color: colors.sideText,
          borderColor: colors.line,
        }}
      >
        <div className="tc-html-preview__side-head">
          <span
            className="tc-html-preview__side-toggle"
            style={{ color: colors.sideText }}
          >
            <MenuIcon sx={{ fontSize: 16 }} />
          </span>
          <div
            className="tc-html-preview__logo-plate"
            style={{
              background: colors.logoBg || colors.card,
              color: colors.primary,
            }}
          >
            {logo ? (
              <img className="tc-html-preview__logo" src={logo} alt="" />
            ) : (
              <>
                <span
                  className="tc-html-preview__brand-mark"
                  style={{ background: colors.accent }}
                />
                Logo
              </>
            )}
          </div>
        </div>
        {APP_NAV.map((label, i) => (
          <div
            key={label}
            className="tc-html-preview__nav-item"
            style={
              i === activeIndex
                ? {
                    background: colors.activeNav,
                    color: navActive,
                    fontWeight: 600,
                  }
                : { opacity: 0.78 }
            }
          >
            {label}
          </div>
        ))}
      </aside>
      <div className="tc-html-preview__main">
        <div className="tc-html-preview__top">
          <div
            className="tc-html-preview__user-plate"
            style={{ background: colors.card, borderColor: colors.line }}
          >
            <div
              className="tc-html-preview__avatar"
              style={{ background: colors.primary }}
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}

function ThemeCatalog(props) {
  const selectedAccount = props.selectedAccount;
  const savedThemeId = selectedAccount?.attributes?.themeId;
  const [themeId, setThemeId] = useState(
    isThemeId(savedThemeId) ? savedThemeId : "default"
  );
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setThemeId(isThemeId(savedThemeId) ? savedThemeId : "default");
  }, [selectedAccount?.id, savedThemeId]);

  if (!selectedAccount) {
    return null;
  }

  const meta = THEME_PREVIEWS[themeId] || THEME_PREVIEWS.default;
  const canUpdate = checkPrivileges("userUpdate");
  const isUnchanged = themeId === savedThemeId;

  const handleSave = (e) => {
    if (e) e.preventDefault();
    if (!canUpdate || saving || isUnchanged) return;

    const attributes = {
      ...(selectedAccount.attributes || {}),
      themeId,
    };
    delete attributes.customTheme;

    const accountData = {
      ...selectedAccount,
      attributes,
    };

    setSaving(true);
    apiFetch(`/api/accounts/${selectedAccount.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(accountData),
    })
      .then((response) => {
        return response.json().then((res) => {
          if (res.status === "success") {
            const account = res.data;
            if (props.UpdateSelectedItem) {
              props.UpdateSelectedItem(account);
            }
            props.dispatch(updateAccount(account));
            props.dispatch(
              notifySuccess(props.translate("themeUpdated"))
            );
          } else if (res?.statusCode === "440") {
            window.location.replace("/login");
          } else if (res.statusCode) {
            const err = res?.message?.split(":");
            if (err && err[1]) {
              err[1] = err[1].replace(")", "");
              props.dispatch(notifyError(props.translate(err[1])));
            } else {
              props.dispatch(
                notifyError(
                  res.message || props.translate("somethingWentWrong")
                )
              );
            }
          } else {
            throw response;
          }
        });
      })
      .catch(() => {
        props.dispatch(
          notifyError(props.translate("somethingWentWrong"))
        );
      })
      .finally(() => {
        setSaving(false);
      });
  };

  return (
    <div className="theme-catalog">
      <form onSubmit={handleSave}>
        <div className="theme-catalog__panel">
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item md={4} sm={6} xs={12}>
              <TextField
                id="catalog-theme"
                className="theme-catalog__field"
                select
                label={props.translate("changeTheme")}
                value={themeId}
                onChange={(e) => {
                  if (isThemeId(e.target.value)) {
                    setThemeId(e.target.value);
                  }
                }}
                margin="dense"
                fullWidth
                InputProps={{
                  readOnly: canUpdate ? false : true,
                }}
              >
                {FLOTILLA_THEMES.map((id) => (
                  <MenuItem key={id} value={id}>
                    <span className="theme-catalog__option">
                      <span
                        className="theme-catalog__swatch"
                        style={{
                          background: THEME_PREVIEWS[id].swatch,
                        }}
                      />
                      {THEME_PREVIEWS[id].cmsLabel}
                      <span className="theme-catalog__option-id">({id})</span>
                    </span>
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            {canUpdate ? (
              <Grid item md={4} sm={6} xs={12}>
                <Button type="submit" disabled={saving || isUnchanged}>
                  {props.translate("update")}
                </Button>
              </Grid>
            ) : null}
          </Grid>
        </div>
      </form>

      <ThemeBadgeRow colors={meta.colors} />

      <div className="theme-catalog__preview">
        <HtmlPreview
          colors={meta.colors}
          activeNav="Trackers"
          logo={selectedAccount?.attributes?.logo}
        >
          <TrackerCompactBody colors={meta.colors} />
        </HtmlPreview>
      </div>
    </div>
  );
}

export default withTranslationWrapper(ThemeCatalog);
